/* External */
import { Record } from 'immutable';
import { combineReducers } from 'redux-immutable';
import mapValues from 'lodash-es/mapValues';

/* Reducers */
import contents from './contents/reducer';
import pages from './pages/reducer';
import requests from './requests/reducer';
import seasons from './seasons/reducer';
import carousels from './carousels/reducer';
import shows from './shows/reducer';
import channels from './channels/reducer';
import schedules from './schedules/reducer';
import status from './status/reducer';
import profile from './profiles/reducer';
import modal from './modal/reducer';
import pdpHistory from './pdpHistory/reducer';

const reducersToCombine = {
  contents,
  pages,
  requests,
  seasons,
  carousels,
  shows,
  channels,
  schedules,
  status,
  profile,
  modal,
  pdpHistory,
};

const DefaultStateCreator = Record(mapValues(reducersToCombine, () => {}));

export default combineReducers(reducersToCombine, DefaultStateCreator);
